import React from 'react';

export default function AdvisorIcon({ size = 18, title = 'Adviseur' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      focusable="false"
      style={{ flexShrink: 0 }}
    >
      <title>{title}</title>
      <path
        d="M8.5 20.5h7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12 3.5c4.14 0 7.5 2.98 7.5 6.65 0 2.18-1.2 4.1-3.08 5.34-.4.26-.67.67-.77 1.14l-.22 1.02c-.12.56-.61.96-1.18.96h-4.5c-.57 0-1.06-.4-1.18-.96l-.22-1.02c-.1-.47-.37-.88-.77-1.14C5.7 14.25 4.5 12.33 4.5 10.15 4.5 6.48 7.86 3.5 12 3.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.2c0 .83-.67 1.5-1.5 1.5S6 11.03 6 10.2 6.67 8.7 7.5 8.7 9 9.37 9 10.2Z"
        fill="currentColor"
      />
      <path
        d="M18 10.2c0 .83-.67 1.5-1.5 1.5S15 11.03 15 10.2s.67-1.5 1.5-1.5S18 9.37 18 10.2Z"
        fill="currentColor"
      />
      <path
        d="M9.5 13.7c.75.6 1.6.9 2.5.9s1.75-.3 2.5-.9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
